import React from 'react';
import Icon from '@mdi/react';
import { mdiPlay } from '@mdi/js';
import './YouTubeEmbed.css';

const YouTubeEmbed = ({ videoId, title }) => {
    if (videoId) {
        return (
            <div className="youtube-embed-container">
                <div className="youtube-embed-wrapper">
                    <iframe
                        src={`https://www.youtube-nocookie.com/embed/${videoId}`}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="lazy"
                        className="youtube-embed-iframe"
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="youtube-embed-container">
            <div className="youtube-embed-placeholder">
                <div className="youtube-embed-play-button">
                    <Icon path={mdiPlay} size={2} />
                </div>
                <span className="youtube-embed-title">{title}</span>
                <span className="youtube-embed-coming-soon">Coming soon</span>
            </div>
        </div>
    );
};

export default YouTubeEmbed;
